import React from 'react';

import AddProductButton from '../../../../components/add-product-button/add-product-button';
import NeedItNow from '../../../../components/need-it-now/need-it-now';
import ProductQuantity from '../../../../components/product-quantity/product-quantity';
import QuantityDisclaimer from '../../../../components/quantity-disclaimer/quantity-disclaimer';

import { useProductEntryDataLayerValues } from '../../../../shared/hooks/hooks';

import { trackAction } from '../../../../shared/utils/analytics/analytics';

import { StoreData } from '../../../../shared/types/graphql-types';
import { ProductItem } from '../../../../shared/types/product';

import styles from './pdp-add-to-cart-section.scss';

interface PdpAddToCartSectionProps {
  defaultQuantity: number;
  isCanonicalProduct: boolean;
  isDisabled?: boolean;
  isSet?: boolean;
  isStaggered: boolean;
  myStore: StoreData | null;
  productItem: ProductItem;
  productType: string;
  storeCode?: string | null;
  updateQuantity: (e: Event, quantity: number) => void;
}

function PdpAddToCartSection(props: PdpAddToCartSectionProps) {
  const {
    defaultQuantity,
    isCanonicalProduct,
    isDisabled = false,
    isSet,
    isStaggered,
    myStore,
    productItem,
    productType,
    storeCode,
    updateQuantity
  } = props;

  const { prebuiltPackage, product, quantity, rearQuantity } = productItem;

  const { getProductEntryDataLayerValues } = useProductEntryDataLayerValues();

  return (
    <>
      <div className={styles['actions']}>
        {!isStaggered && !isSet && (
          <ProductQuantity
            aria-label="quantity-input"
            className={styles['quantity']}
            defaultValue={defaultQuantity}
            id="quantity"
            isHorizontal
            onBlur={updateQuantity}
            onChange={updateQuantity}
            showLabel
            value={quantity}
          />
        )}

        <AddProductButton
          isDisabled={isDisabled}
          onClick={() =>
            trackAction(
              'product_detail_cart_add',
              getProductEntryDataLayerValues(product, quantity, rearQuantity)
            )
          }
          productItem={productItem}
          storeCode={storeCode}
        />
      </div>
      {!prebuiltPackage && !isStaggered && (
        <QuantityDisclaimer
          className={styles['quantity-disclaimer']}
          productType={productType}
          quantity={quantity}
        />
      )}
      {!isCanonicalProduct && (
        <NeedItNow
          className={styles['need-it-now']}
          phone={myStore?.address?.phone}
          productType={productType}
        />
      )}
    </>
  );
}

export default PdpAddToCartSection;
